<template>
    <div class="location-block container">
        <h2>Место проведения</h2>
        <div class="__row __location">
            <div class="__col">
                <div class="__map">
                    <MapBlock/>
                </div>
            </div>
            <div class="__col __address-wrap">
                <div class="__hotel">{{ contacts.address.b3 }}</div>
                <div class="__spb">{{ contacts.address.b1 }}</div>
                <div class="__addr">
                    <a :href="contacts.address.url">
                        <img :src="contacts.address.icon" alt="">
                        {{ contacts.address.b2 }}
                    </a>
                </div>
                <div class="__metro">
                    <img :src="contacts.metro.icon" alt="">
                    {{ contacts.metro.title }}
                </div>
            </div>
        </div>
        <div class="__row __images">
            <div v-for="(img, index) in contacts.address.image" 
                :key="index"
                class="__col"
                >
                <div class="__img">
                    <img :src="img" alt="hotel photo">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import contacts from '@/lib/contacts';
import MapBlock from '@/components/MapBlock.vue';
export default {
    name: 'LocationBlock',
    components: { MapBlock },
    props: {},
    data() {
        return {
            contacts
        }
    },
    mounted() {
    },
    methods: {}
}
</script>
<style lang="scss">
$text-color: #fff;
.location-block{
    .__row.__location{
        display: flex;
        flex-direction: column;
        text-align: left;
        margin-bottom: 1.5em;
        // .__map{
        //     // display: flex;
        //     // border-radius: 16px;
        //     // overflow: hidden;
        //     // padding: 0;
        //     // margin: 0;
        //     // background-color: aqua;
        //     // object-fit: contain;
        //     // img{
        //     //     width: 100%;
        //     //     height: auto;
        //     // }
        //     // width: 633px;
        //     // height: 400px;
        // }
        .__address-wrap{
            flex-basis: 33%;
            padding-left: 8px;
            $margin-bottom: 10px;
            .__hotel{
                margin-bottom: $margin-bottom;
                text-transform: uppercase;
                font-weight: 600;
                font-size: 1.65em;
                color: $text-color;
            }
            .__spb{
                margin-bottom: 20px;
                text-transform: uppercase;
                font-weight: 200;
                font-size: 1.2em;
                color: $text-color;
            }
            .__addr{
                a{
                    font-weight: 200;
                    font-size: 1em;
                    color: $text-color;
                    text-decoration: none;
                    border-bottom: solid 1px $text-color;
                }
                margin-bottom: 15px;
                // text-transform: none;
                font-weight: 200;
                font-size: 1em;
                color: $text-color;
                display: flex;
                align-items: center;
                img{
                    padding-right: 5px;
                    width: 20px;
                    height: 20px;
                }
            }
            .__metro{
                margin-bottom: $margin-bottom;
                // text-transform: uppercase;
                font-weight: 200;
                font-size: 1em;
                color: $text-color;
                display: flex;
                align-items: center;
                img{
                    padding-right: 5px;
                    width: 20px;
                    height: 20px;
                }
            }
        }
        @media ( min-width: 992px ) {
            flex-direction: row;
            .__col{
                &:nth-child(1){
                    flex-basis: 66%;
                }
            }
        }
    }
    .__row.__images{
        display: flex;
        justify-content: center;
        flex-basis: 20px;
        flex-wrap: wrap;
        margin-bottom: 1.5em;
        .__col{
            padding: 2px;
            flex-basis: 47%;
            @media ( min-width: 992px ) {
                flex-basis: 24%;
            }
            .__img{
                height: 180px;
                border-radius: 15px;
                // width: 100px;
                overflow: hidden;
                img{
                    display: block;
                    object-fit: cover;
                    object-position: center;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
}
</style>